import { useEffect, useState } from 'react';

import { isDeviceKiosco } from '@/modules/perseo-billing/utils';
interface MessageOut {
  type: 'changeLocation' | 'goHome' | 'getConfig' | 'commitOrder';
  value: unknown;
}

export const PinpadUrl = {
  development:
    'https://kiosco-pinpad-paris-cl-test-proxy.firebaseapp.com/kiosco-payment-methods.js',
  staging:
    'https://kiosco-pinpad-paris-cl-test-proxy.firebaseapp.com/kiosco-payment-methods.js',
  production:
    'https://kiosco-pinpad-paris-cl-prod-proxy.firebaseapp.com/kiosco-payment-methods.js',
  'staging-v2':
    'https://kiosco-pinpad-paris-cl-stg-v2.firebaseapp.com/kiosco-payment-methods.js',
  'production-v2':
    'https://kiosco-pinpad-paris-cl-prod-v2.firebaseapp.com/kiosco-payment-methods.js'
};

enum TypeToReceive {
  config = 'config',
  commitOrderStatusResponse = 'commitOrderStatusResponse'
}

type MessageIn = {
  type: TypeToReceive;
  value: unknown;
};

interface Config {
  pinpadKey: keyof typeof PinpadUrl;
  version: string;
  kioskName: string;
  seller: string;
}

declare global {
  interface Window {
    commitOrder: (order: {
      orderNumber: string;
      pinpadResponse: unknown;
    }) => void;
  }
}

export function sendMessageToKiosco(message: MessageOut) {
  const isKiosco = isDeviceKiosco();
  if (!isKiosco) return;
  const origins = import.meta.env.VITE_ALLOWED_KIOSCO_ORIGINS;

  if (typeof origins !== 'string') {
    console.warn(
      'la variable VITE_ALLOWED_KIOSCO_ORIGINS tiene que ser definida en el proyecto mf-checkout'
    );
    return;
  }

  const allowedOrigins: string[] = origins.split(';') || [];

  for (const origin of allowedOrigins) {
    parent.postMessage(
      {
        type: message.type,
        value: message.value
      },
      origin
    );
  }
}

export function useKiosco() {
  const [config, setConfig] = useState<Config | null>(null);
  const [commitOrderStatus, setCommitOrderStatus] = useState<null | unknown>(
    null
  );
  const isKiosco = isDeviceKiosco();

  useEffect(() => {
    if (!isKiosco) return;

    sendMessageToKiosco({
      type: 'changeLocation',
      value: window.location.pathname
    });

    sendMessageToKiosco({
      type: 'getConfig',
      value: null
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isKiosco) return;
    const messageListener = (event: MessageEvent<MessageIn>) => {
      if (event.origin !== '') {
        const message = event.data;

        switch (message.type) {
          case TypeToReceive.config:
            setConfig(message.value as Config);
            break;
          case TypeToReceive.commitOrderStatusResponse:
            setCommitOrderStatus(message.value);
            break;
          default:
            setCommitOrderStatus(message.value);
        }
      }
    };

    window.addEventListener('message', messageListener);
    return () => {
      window.removeEventListener('message', messageListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { sendMessageToKiosco, config, commitOrderStatus };
}
